<!-- Facility Jobs Card -->
<div *ngIf="facilityCardData.length" class="card mb-3">
  <div
    [ngClass]="{
      card: true,
      selected:
        selectedCard?.id == cardData?.id &&
        selectedCard?.potentialJobDetail?.jobs[0]?.departmentId == cardData?.potentialJobDetail?.jobs[0]?.departmentId
    }">
    <div class="card-body pb-0">
      <div class="d-flex justify-content-between">
        <h5 (click)="openJobSideNav(cardData)" class="card-title facility-name">
          {{ cardData?.owner?.owner_name }} | {{ cardData?.facilityName }} ({{ facilityCardData.length || '0' }})
          <a href="owner_info/add_edit;id={{ cardData?.owner?.id }}" target="_blank"
            ><img src="/assets/images/icon/openFacility.svg"
          /></a>
        </h5>
        <div class="dropdown dropleft">
          <button
            class="btn btn-primary"
            type="button"
            id="job-pointe-export"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            Export
          </button>
          <div class="dropdown-menu" aria-labelledby="job-pointe-export">
            <a class="dropdown-item" *ngIf="isAllowed('job_board_attributes', 'view')">
              <button type="button" class="btn capitalize" (click)="emitExport('siteCrewList')">
                Export site crew list
              </button>
            </a>

            <a class="dropdown-item" *ngIf="isAllowed('job_board_attributes', 'edit')">
              <button type="button" class="btn capitalize" (click)="emitExport('siteHrList')">
                Export site hr data
              </button>
            </a>
          </div>
        </div>
      </div>
      <div class="form-group form-inline">
        <label style="padding-right: 5px" class="form-label" for="alias">Alias: </label>
        <input
          (focusout)="setFacilityAlias($event, cardData)"
          class="form-control w-50 h-25"
          type="text"
          name=""
          id="alias"
          placeholder="Card Alias"
          [value]="cardData?.jobBoardAlias"
          [readonly]="!isAllowed('job_board_attributes', 'edit')" />
      </div>
      <div class="card-body d-flex justify-content-between px-0 py-1">
        <a
          href="https://maps.google.com/?q={{ getFacilityAddress() }}"
          target="_blank"
          class="card-link text-dark bold">
          <img src="/assets/images/icon/location.svg" />
          {{ getFacilityAddress() }}
        </a>
        <p class="card-text text-secondary">Avg. Crew Cost: <span class="text-dark bold"></span></p>
      </div>
      <p class="card-text pt-1 text-secondary">
        Site Locals: <span class="text-dark bold">{{ getFacilitySiteLocals() }}</span>
      </p>
      <div>
        <ul class="list-group draggable-box" droppable (onDrop)="assignTag($event, cardData)">
          <li *ngFor="let tagAssignment of getCardTags(cardData); trackBy: trackByTagId" class="list-group-item">
            <app-job-board-tags
              [removable]="true"
              (delete)="removeCardTag(tagAssignment, cardData)"
              [tag]="tagAssignment?.tag"
              [tagShape]="tagAssignment?.tag?.shape"></app-job-board-tags>
          </li>
        </ul>
      </div>
      <hr />
      <p class="card-text d-flex align-items-center">
        Project Managers:
        <span class="ml-4 d-inline-block" title="" style="max-width: 480px">
          {{ getProjectManagersList('facility') }}
        </span>
      </p>
      <div class="card-body px-0 py-1 d-flex">
        <p class="card-text w-25 d-flex" style="align-items: center">Main Foreman:</p>
        <div class="form-group w-75">
          <app-autocomplete-dropdown
            *ngIf="foremanList?.length"
            bindLabel="name"
            bindVal="name"
            [selectedItems]="cardData?.jobBoardMainForeman"
            label="Select Main Foreman"
            dropdownType="multiple"
            [inputItems]="foremanList"
            dropdownPosition="bottom"
            #mainForemanDropdown
            type="foremanSelection"
            (filter)="setFacilityMainForeman($event, cardData)"
            [ngClass]="{ 'disabled-list': isListDisabled() }">
          </app-autocomplete-dropdown>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" class="main_foreman multiCheckVal" #main_foreman />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="card-body p-0">
    <div *ngIf="isAllowed('job_board_attributes', 'edit')" class="card-header w-100">
      <button
        [disabled]="jobBoardLocked"
        (click)="openAddEmployeeModal('Facility', cardData)"
        class="btn btn-primary add-employee-btn"
        style="width: inherit">
        Add Employee <img src="/assets/images/icon/plus.svg" />
      </button>
    </div>
    <div class="card-footer text-muted bg-white py-1 d-flex">
      <div class="card-body px-0 py-1 d-flex justify-content-between">
        <a href="javascript:void(0);" class="card-link footer-text"
          >Last job added: {{ getLastAddedJob(cardData?.potentialJobDetail?.jobs) }}
        </a>
        <a href="javascript:void(0);" class="card-link text-danger">
          <a
            *ngIf="isAllowed('job_board_attributes', 'edit') && isAllowed('job_pointe_employees', 'edit')"
            href="javascript:;"
            class="mx-1"
            data-toggle="collapse"
            [attr.data-target]="'#notes' + cardDepartment + cardData.id + id">
            <img *ngIf="cardData?.jobBoardNotes !== null" src="/assets/images/icon/notes.svg" />
            <img *ngIf="cardData?.jobBoardNotes === null" src="/assets/images/icon/notes_gray.svg" />
          </a>
          <img src="/assets/images/icon/user.svg" />
          ({{ cardData?.scheduleEmployees?.length || '0' }})
        </a>
        <div [ngClass]="{ collapse: true }" [id]="'notes' + cardDepartment + cardData.id + id" aria-expanded="false">
          <div style="width: 265px" class="form-group">
            <textarea
              (focusout)="setFacilityNotes($event, cardData)"
              [value]="cardData?.jobBoardNotes"
              class="form-control"
              placeholder="Add Card notes"
              id="message-text"
              rows="5"></textarea>
          </div>
        </div>
      </div>
      <img
        (click)="stateChange('isCollapsed', !getState('isCollapsed'))"
        class="mx-2 employee-expand"
        #collapseIcon
        data-toggle="collapse"
        [attr.data-target]="'#facility' + cardDepartment + cardData.id + id"
        src="/assets/images/icon/down-arrow.svg" />
    </div>
    <div #facilityCollapseDiv [ngClass]="{ collapse: true }" [id]="'facility' + cardDepartment + cardData.id + id">
      <div
        *ngIf="cardData?.scheduleEmployees?.length; else noAssignedEmployees"
        class="card card-body employee-card-container p-0">
        <!-- Profile card -->
        <div *ngFor="let employee of getCardEmployees(cardData.scheduleEmployees); trackBy: trackByEmployeeId">
          <app-job-employee-card
            droppable
            (onDrop)="assignTag($event, employee)"
            (onEraseTag)="removeCardTag($event, cardData)"
            [tagAssignments]="tagAssignments"
            [employee]="employee"
            [job]="cardData"></app-job-employee-card>
        </div>
      </div>
      <ng-template #noAssignedEmployees>
        <div class="no-assigned-employees">
          <p>No employees assigned</p>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<!-- Stand-alone Job Card -->
<div *ngFor="let jobCardData of separateJobCardData; trackBy: trackByJobId" class="card mb-3">
  <div class="card">
    <div class="card-body pb-0" [ngClass]="{ highlighted: jobCardData?.jobDetail?.number }">
      <div class="d-flex justify-content-between">
        <h5 (click)="openJobSideNav(jobCardData)" class="card-title job-name">
          {{ jobCardData?.jobDetail?.number }} -
          {{ jobCardData.name }}
          <a href="/jobs/{{ jobCardData?.jobDetail?.id }}" target="_blank"
            ><i style="font-size: small" class="fa fa-external-link fa-1x" aria-hidden="true"></i
          ></a>
        </h5>
        <div class="dropdown dropleft">
          <button
            class="btn btn-primary"
            type="button"
            id="job-pointe-export"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false">
            Export
          </button>
          <div class="dropdown-menu" aria-labelledby="job-pointe-export">
            <a class="dropdown-item" *ngIf="isAllowed('job_board_attributes', 'view')">
              <button type="button" class="btn capitalize" (click)="emitExport('siteCrewList', jobCardData)">
                Export site crew list
              </button>
            </a>
            <a class="dropdown-item" *ngIf="isAllowed('job_board_attributes', 'edit')">
              <button type="button" class="btn capitalize" (click)="emitExport('siteHrList', jobCardData)">
                Export site hr data
              </button>
            </a>
          </div>
        </div>
      </div>
      <div class="form-group form-inline">
        <label style="padding-right: 5px" class="form-label" for="alias">Alias: </label>
        <input
          (focusout)="setJobAlias($event, jobCardData)"
          class="form-control w-50 h-25"
          type="text"
          name=""
          id="alias"
          placeholder="Card Alias"
          [value]="jobCardData?.jobBoardAlias" />
      </div>
      <div class="card-body d-flex justify-content-between px-0 py-1">
        <a
          href="https://maps.google.com/?q={{ getFacilityAddress() }}"
          target="_blank"
          class="card-link text-dark bold">
          <img src="/assets/images/icon/location.svg" />
          {{ getFacilityAddress() }}</a
        >
      </div>
      <div class="card-body d-flex justify-content-between px-0 py-1">
        <p class="card-text pt-1 text-secondary">
          Department: <span class="text-dark bold">{{ jobCardData?.departmentNumber }}</span>
        </p>
        <!-- <p class="card-link text-secondary">Job Cost: <span class="text-dark bold">{{formatToCurrency(jobCardData?.estimatedCost)}}</span></p> -->
      </div>
      <div class="card-body d-flex justify-content-between px-0 py-1">
        <p class="card-text pt-1 text-secondary">
          Site Local: <span class="text-dark bold">{{ jobCardData?.jobDetail?.unionLocal?.unionLocalId }}</span>
        </p>
        <p class="card-link text-secondary">
          Project End Date: <span class="text-dark bold">{{ formatDate(jobCardData?.jobDetail?.endDate) }}</span>
        </p>
      </div>
      <div>
        <ul class="list-group draggable-box" droppable (onDrop)="assignTag($event, jobCardData)">
          <li *ngFor="let tagAssignment of getCardTags(jobCardData); trackBy: trackByTagId" class="list-group-item">
            <app-job-board-tags
              [removable]="true"
              (delete)="removeCardTag(tagAssignment, jobCardData)"
              [tag]="tagAssignment?.tag"
              [tagShape]="tagAssignment?.tag?.shape"></app-job-board-tags>
          </li>
        </ul>
      </div>
      <hr />
      <p class="card-text d-flex align-items-center">
        Project Managers:
        <span class="ml-4 d-inline-block text-truncate" title="" style="max-width: 480px">
          {{ getProjectManagersList('job') }}
        </span>
      </p>
      <div class="card-body px-0 py-1 d-flex">
        <p class="card-text w-25 d-flex" style="align-items: center">Main Foreman:</p>
        <div class="form-group w-75">
          <app-autocomplete-dropdown
            [selectedItems]="jobCardData?.jobBoardMainForeman"
            *ngIf="foremanList?.length"
            bindLabel="name"
            label="Select Main Foreman"
            bindVal="name"
            (filter)="setJobMainForeman($event, jobCardData)"
            dropdownType="multiple"
            [inputItems]="foremanList"
            #mainForemanDropdown
            [ngClass]="{ 'disabled-list': isListDisabled() }"
            type="foremanSelection">
          </app-autocomplete-dropdown>
          <div style="width: 0 !important; height: 0 !important; overflow: hidden !important">
            <input type="text" class="main_foreman multiCheckVal" #main_foreman />
          </div>
        </div>
      </div>
    </div>
    <div class="card-body p-0">
      <div
        *ngIf="isAllowed('job_board_attributes', 'edit')"
        class="card-header w-100"
        [ngClass]="{ highlighted: jobCardData?.jobDetail?.number }">
        <button
          [disabled]="jobBoardLocked"
          (click)="openAddEmployeeModal('Job', jobCardData)"
          class="btn btn-primary add-employee-btn"
          style="width: inherit">
          Add Employee <img src="/assets/images/icon/plus.svg" />
        </button>
      </div>
      <div class="card-footer text-muted py-1 d-flex" [ngClass]="{ highlighted: jobCardData?.jobDetail?.number }">
        <div class="card-body px-0 py-1 d-flex justify-content-between">
          <a href="javascript:void(0);" class="card-link footer-text"
            >Job added: {{ getLastAddedJob([jobCardData]) }}</a
          >
          <a href="javascript:void(0);" class="card-link text-danger">
            <a
              *ngIf="isAllowed('job_board_attributes', 'edit')"
              href="javascript:;"
              class="mx-1"
              data-toggle="collapse"
              [attr.data-target]="'#notes' + cardDepartment + jobCardData.id + id">
              <img src="/assets/images/icon/notes.svg" />
            </a>
            <img src="/assets/images/icon/user.svg" />
            ({{ jobCardData?.scheduleEmployees?.length || '0' }})
          </a>
          <div
            [ngClass]="{ collapse: true }"
            [id]="'notes' + cardDepartment + jobCardData.id + id"
            aria-expanded="false">
            <div style="width: 265px" class="form-group">
              <textarea
                (focusout)="setJobNotes($event, jobCardData)"
                [value]="jobCardData?.jobBoardNotes"
                class="form-control"
                placeholder="Add Card notes"
                id="message-text"
                rows="5"></textarea>
            </div>
          </div>
        </div>
        <img
          (click)="stateChange('isCollapsed', !getState('isCollapsed'))"
          class="mx-2 employee-expand"
          data-toggle="collapse"
          [attr.data-target]="'#job' + cardDepartment + jobCardData.id + id"
          src="/assets/images/icon/down-arrow.svg" />
      </div>
      <div #jobCollapseDiv [ngClass]="{ collapse: true }" [id]="'job' + cardDepartment + jobCardData.id + id">
        <div *ngIf="jobCardData?.scheduleEmployees?.length; else noAssignedEmployees" class="card card-body employee-card-container p-0">
          <!-- Profile card -->
          <div *ngFor="let employee of getCardEmployees(jobCardData.scheduleEmployees); trackBy: trackByEmployeeId">
            <app-job-employee-card
              droppable
              (onDrop)="assignTag($event, employee)"
              (onEraseTag)="removeCardTag($event, jobCardData)"
              [tagAssignments]="tagAssignments"
              [employee]="employee"
              [job]="jobCardData"></app-job-employee-card>
          </div>
          <ng-template #noAssignedEmployees>
            <div>No employees assigned.</div>
          </ng-template>
        </div>
        <ng-template #noAssignedEmployees>
          <div class="no-assigned-employees">
            <p>No employees assigned</p>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- Notes Modal -->
<div
  class="modal fade"
  id="notesModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="notesModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="isAllowed('job_board_attributes', 'edit')" class="modal-title text-center" id="notesModalLabel">
          Notes
        </h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <textarea class="form-control" placeholder="Add Card notes" id="message-text" rows="5"></textarea>
        </div>
      </div>
      <div class="modal-footer pb-3">
        <button type="button" class="btn btn-green">Save changes</button>
        <button type="button" class="btn btn-gray" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
</div>
